module.exports = __webpack_public_path__ + "static/img/default_red.2c1999d6.png";